import type { FaireProductEntity } from "../../entity_types/product";

export const p_yehdsb5grb: FaireProductEntity = {
  token: "p_yehdsb5grb",
  type: "product",
  name: "Heirloom Heat Checked Olive & Tomato Terry Cloth Hand Towel",
  brandToken: "b_89sio4o216",
  brandName: "One & Only Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/9cd1cdd53739a854a86bb527ada33024bfa2091f7618d27ae528320e930d5e2b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9c41cf4355d14bb76fe5aba08b16d45a82ba1f9ff01d6229a2e48e2cd627562e.jpeg",
    "https://cdn.faire.com/fastly/6cf565d5d7b81c154824e15cdc02d29461801afd5bee96daace5adf020db0171.jpeg",
    "https://cdn.faire.com/fastly/5b54941d819537d8837e89587105e0b1ee58db517d1bb1c857763a8498ea01aa.jpeg",
    "https://cdn.faire.com/fastly/dda71cfc4e8c3000fbc362c7021c3c74d70811bb994918cab2d5f853ac3829fa.jpeg",
  ],
  priceDollars: 14,
  description:
    'Inspired by summer farmer’s markets and the deep, punchy hues of ripe tomatoes and briny olives. This bold, playful design brings the garden inside with just the right amount of retro charm.\n\nDetails:\n\n100% cotton terry cloth\nMade in the USA\nMeasures 16" x 24"\nMachine washable\nUse as hand towel or kitchen towel\n',
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:13:14.615Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
